var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisaBlueIcon = function SvgVisaBlueIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8bb7f0",
    d: "M2 19.5c-.827 0-1.5-.673-1.5-1.5V2C.5 1.173 1.173.5 2 .5h24c.827 0 1.5.673 1.5 1.5v16c0 .827-.673 1.5-1.5 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M26 1c.551 0 1 .449 1 1v16c0 .551-.449 1-1 1H2c-.551 0-1-.449-1-1V2c0-.551.449-1 1-1zm0-1H2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.109 6.001-1.876 5.695s-.466-2.329-.514-2.632C4.651 6.583 3.065 6.642 3.065 6.642L4.924 14v-.001h2.258l3.122-7.998zM9.897 14h2.051l1.24-7.999h-2.076zm14.514-7.999h-2.158L18.889 14h2.037l.42-1.142h2.569L24.134 14H26zm-2.496 5.329 1.116-3.023.584 3.023zm-5.817-2.998c0-.441.356-.769 1.376-.769.663 0 1.422.49 1.422.49l.333-1.679s-.97-.375-1.922-.375c-2.156 0-3.269 1.05-3.269 2.379 0 2.404 2.842 2.075 2.842 3.31 0 .212-.165.701-1.349.701-1.187 0-1.971-.443-1.971-.443l-.354 1.611s.759.441 2.226.441c1.471 0 3.511-1.12 3.511-2.728.001-1.934-2.845-2.074-2.845-2.938"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "m5.97 10.353-.675-3.482s-.312-.748-1.124-.748H.999s4.03 1.245 4.971 4.23"
  })));
};
export default SvgVisaBlueIcon;